import { Dispatcher } from '../dispatcher/Dispatcher';
import { ActionTypes } from '../constants/ActionTypes';

export const NotificationServerActionCreators = {
  updateLastCheckedTime: (channelId, subscriptionId, checkedTime) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATION_CHECKED_TIME,
      channelId,
      subscriptionId,
      lastCheckedTime: checkedTime,
    });
  },

  setAllNotificationsChecked: (lastCheckedTime) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATIONS_ALL_CHECKED_TIME,
      lastCheckedTime,
    });
  },

  updateLastSeenTime: (seenTime) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATIONS_SEEN_TIME,
      seenTime,
    });
  },

  updateNotifications: (notifications) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATION_UPDATE,
      notifications,
    });
  },

  setFilterStatus: (actionType, includeRead, earliestTime, complete) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATION_FILTER_STATUS,
      actionType,
      includeRead,
      earliestTime,
      complete,
    });
  },

  setLoadingStatus: (actionType, includeRead, loading) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATION_LOADING_STATUS,
      actionType,
      includeRead,
      loading,
    });
  },

  updateSettings: (settings) => {
    Dispatcher.dispatch({
      type: ActionTypes.NOTIFICATION_SETTINGS_UPDATE,
      settings,
    });
  },
};
